import React from 'react'
import { Link } from 'gatsby'
import footerImg from "../images/Logo/LogoFinalWhite.png"
const Footer = () => {
    return (
        <>
            <footer className="main-footer">
                <div className="container px-0">
                    <div className="footer-content">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="logo-widget footer-widget">
                                    {/* <div className ="logo-box pb-3"> */}
                                    <Link to="/">
                                        <img className="pb-5" src={footerImg} width={235} layout="constrained" placeholder="blurred" alt='logo' />
                                    </Link>
                                    {/* </div> */}
                                    <div className="text">
                                        <p>We provide our customers with quality and excellence in web development solutions and digital experiences with our latest technologies and innovative designs, to reach more potential customers.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12 offset-lg-1 footer-column">
                                <div className="service-widget footer-widget">
                                    <div className="footer-title">SERVICES</div>
                                    <span className="dash-dash bg-primary-color"></span>
                                    <ul className="list pl-0 pt-3">
                                        <li><Link to="/services/web-development/" title='Web Design & Development Services'>Web Design & Development</Link></li>
                                        <li><Link to="/services/mobile-app-development/" title='Mobile App Development Services'>Mobile App Development</Link></li>
                                        <li><Link to="/services/software-development/" title='Software Development Services'>Software Development</Link></li>
                                        <li><Link to="/services/ui-design/" title='UI/UX Design Services'>UI/UX Design</Link></li>
                                        <li><Link to="/services/quality-assurance/" title='Quality Assurance Services'>Quality Assurance</Link></li>
                                        <li><Link to="/services/graphics-design/" title='Graphics Design Services'>Graphics Design</Link></li>
                                        <li><Link to="/services/search-engine-optimization/" title='Search Engine Optimization'>Search Engine Optimization</Link></li>
                                        <li><Link to="/services/cloud-computing/" title='Cloud Computing Services'>Cloud Computing</Link></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 footer-widget">
                                <div className="contact-widget footer-widget">
                                    <div className="footer-title">CONTACTS</div>
                                    <span className="dash-dash bg-primary-color"></span>
                                    <div className="text pt-3">
                                        <p style={{ fontSize: "14px" }}>First Floor, Pak Tower, Office No 105, 106 Range Rd, opposite Punjab Cash & Carry, Rawalpindi</p>
                                        <p className="mb-0"><a href="tel:+923335486656">+92 333 5486656</a></p>
                                        <p>
                                            {/* <Link to="">info@codefrenetics.com</Link> */}
                                            <a href='mailto:info@codefrenetics.com' target={"_blank"} rel="noopener noreferrer" aria-label="Send email">
                                                info@codefrenetics.com
                                            </a>
                                        </p>
                                    </div>
                                    <h3 className="mt-5 white footer-title pt-3" style={{ lineHeight: "1.7" }}>FOLLOW US ON:</h3>
                                    <span className="dash-dash bg-primary-color width-15-per"></span>
                                    <ul className="footer-social pl-0 pt-3">
                                        <li>
                                            <a href="https://www.facebook.com/Code-Frenetics-101390369213086/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page">
                                                <i className="fab fa-facebook-f" aria-hidden="true"></i>
                                                <span className="sr-only">Facebook</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.instagram.com/codefrenetics/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Instagram profile" >
                                                <i className="fab fa-instagram" aria-hidden="true"></i>
                                                <span className="sr-only">Instagram</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/FreneticsApps" target="_blank" rel="noopener noreferrer" aria-label="Visit our Twitter profile">
                                                <i className="fab fa-twitter" aria-hidden="true"></i>
                                                <span className="sr-only">Twitter</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/company/code-frenetics" target="_blank" rel="noopener noreferrer" aria-label="Visit our LinkedIn page">
                                                <i className="fab fa-linkedin" aria-hidden="true"></i>
                                                <span className="sr-only">LinkedIn</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            {/* <!-- main-footer end --> */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="row center">
                        <div className="col-lg-12 col-md-12 col-sm-12 column center py-2">
                            <div className="copyright"> <p className="mb-0"> Copyrights &copy;  2017-2025 <Link to="/">Codefrenetics</Link> . All Right Reserved. </p> <Link to="/termsandconditions">Terms and conditions</Link></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer